// =====================================================================
// Instância axios do portal. Injeta o Bearer token e, em 401 (fora das
// rotas públicas de auth), desloga e manda pro /login. Espelha o
// comportamento do interceptor do UEN.
// =====================================================================
import axios from 'axios';
import { currentServer } from '../config';
import { getToken, logout } from '../auth/storage';

const api = axios.create({
    baseURL: currentServer,
    timeout: 45000,
});

// ---- Request: Authorization ----
api.interceptors.request.use((config) => {
    const token = getToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

// ---- Response: desloga em 401 (menos nas rotas públicas de auth) ----
api.interceptors.response.use(
    (res) => res,
    (error) => {
        const status = error?.response?.status;
        const url = String(error?.config?.url || '');

        // Nessas rotas, 401 = "dados incorretos", não sessão expirada.
        const rotaPublicaAuth =
            url.includes('/api/auth/') || url.includes('/api/loginestudantilemailpassw');
        // /api/profile: 401/403 = sessão inválida; 404 = o user do token não existe
        // mais (apagado/migrado). Em qualquer um deles, desloga.
        const profileInvalido = url.includes('/api/profile') && (status === 401 || status === 403 || status === 404);

        if (!rotaPublicaAuth && (status === 401 || profileInvalido)) {
            logout();
            const p = window.location.pathname;
            if (p !== '/login' && p !== '/') {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default api;
